import {
  IgDivider,
  IgLastUpdatedText,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { AccessTime } from "@mui/icons-material";
import { Grid } from "@mui/material";

import { useGetOrg } from "../../../api/organizations/get-organization";
import theme from "../../../theme";
import { fullDateTimeConverter } from "../../../utils/dateConverters";

interface TimezoneLastUpdatedInfoProps {
  showLastUpdatedTime: boolean;
  latestRunTs: number | undefined;
  outerGridXs?: number;
}
export const TimezoneLastUpdatedInfo = ({
  showLastUpdatedTime,
  latestRunTs,
  outerGridXs,
}: TimezoneLastUpdatedInfoProps) => {
  const organization = useGetOrg();
  return (
    <Grid
      xs={outerGridXs || 4.1}
      item
      container
      justifyContent={"flex-end"}
      columnSpacing={3}
      alignItems={"center"}
      wrap={"nowrap"}
    >
      <Grid item>
        <IgTooltip
          title={
            "This is the default timezone of your Shopify store and the timezone Intelligems analytics is set to."
          }
        >
          <Grid item container alignItems={"center"}>
            <AccessTime sx={{ fontSize: "16px" }} />
            <IgTypography
              sx={{
                fontSize: "14px",
                ml: 0.5,
              }}
            >
              {(organization?.data?.org.timezone ?? "UTC")
                .toUpperCase()
                .replaceAll("_", " ")}
            </IgTypography>
          </Grid>
        </IgTooltip>
      </Grid>
      {showLastUpdatedTime && latestRunTs && latestRunTs !== 0 ? (
        <Grid item>
          <IgTooltip
            title={`Data is refreshed about once per hour, the last refresh was at ${fullDateTimeConverter(
              latestRunTs
            )}`}
          >
            <Grid
              item
              container
              direction={"row"}
              alignItems={"center"}
              columnSpacing={1}
            >
              <IgTypography
                sx={{
                  fontSize: "14px",
                }}
              >
                Updated
              </IgTypography>

              <IgLastUpdatedText
                noPrefix={true}
                typographySx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: theme.palette.text.primary,
                  lineHeight: "1.5px",
                }}
                compareTimeMs={latestRunTs}
              />
            </Grid>
          </IgTooltip>
        </Grid>
      ) : null}
    </Grid>
  );
};
